class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold);
    this.currency = this.dataset.currency || '';
    
    // This tells the script to watch for any changes made to the cart
    if (!window.cartWatcherAdded) {
      const originalFetch = window.fetch;
      window.fetch = async (...args) => {
        const response = await originalFetch(...args);
        const url = args[0];
        
        // If a cart action happens (like adding or removing an item)
        if (typeof url === 'string' && url.includes('/cart')) {
          // Wait half a second for Shopify to finish, then update our bar
          setTimeout(() => {
            document.querySelectorAll('free-shipping-bar').forEach(bar => {
              if (bar.updateCart) bar.updateCart();
            });
          }, 500);
        }
        return response;
      };
      window.cartWatcherAdded = true;
    }
  }

  async updateCart() {
    try {
      // Get the latest cart total directly from Shopify
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateBar(cart.total_price);
    } catch (error) {
      console.log("Could not load cart data", error);
    }
  }

  updateBar(totalPrice) {
    this.progressBar = this.querySelector('.shipping-progress');
    this.message = this.querySelector('.shipping-message');

    if (!this.progressBar || !this.message) return;

    // Calculate the new width for the bar
    let percent = (totalPrice / this.threshold) * 100;
    if (percent > 100) percent = 100;
    
    this.progressBar.style.width = percent + '%';

    // Check if we hit the free shipping goal
    if (totalPrice >= this.threshold) {
      this.message.innerHTML = "🎉 You unlocked free shipping!";
      
      if (!window.hasFiredConfetti) {
        this.fireConfetti();
        window.hasFiredConfetti = true; 
      }
    } else {
      let remaining = (this.threshold - totalPrice) / 100;
      this.message.innerHTML = `You are ${this.currency}${remaining.toFixed(0)} away from free shipping!`;
      window.hasFiredConfetti = false; 
    }
  }

  fireConfetti() {
    if (typeof confetti === 'function') {
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 999999 // This high z-index forces the confetti in front of the drawer
      });
    }
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}